import React from 'react';
import { Form, InputNumber } from 'antd';

const InvoiceTotals = ({ form, factors }) => {
  return (
    <div 
      style={{ 
        marginTop: 8, 
        padding: '4px 8px', 
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #6d7bff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '16px',
        fontSize: '12px',
        flexWrap: 'wrap'
      }}
    >
      <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
        المجموع: 
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues.Items !== currentValues.Items;
          }}
        >
          {() => {
            const items = form.getFieldValue('Items') || [];
            let totalResult = 0;
            
            items.forEach(item => {
              const unitPrice = item?.UnitPrice || 0;
              const amount = item?.Amount || 0;
              const discount = item?.Discount || 0;
              totalResult += (unitPrice * amount - discount) * (factors[item?.Currency] || 1);
            });
            
            return (
              <InputNumber
                value={totalResult.toFixed(2)}
                readOnly
                size="small"
                style={{ width: '100px', marginRight: '4px', backgroundColor: '#fff' }}
              />
            );
          }}
        </Form.Item>
        $
      </span>
      
      <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
        خصم: 
        <Form.Item
          name="Discount"
          noStyle
        >
          <InputNumber 
            min={0} 
            size="small" 
            style={{ width: '80px', marginRight: '4px' }} 
          />
        </Form.Item>
        $
      </span>
      
      <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
        الإجمالي بعد الخصم: 
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues.Items !== currentValues.Items || 
                  prevValues.Discount !== currentValues.Discount ||
                  prevValues.Vouchers !== currentValues.Vouchers;
          }}
        >
          {({ getFieldValue }) => {
            const items = getFieldValue('Items') || [];
            const discount = getFieldValue('Discount') || 0;

            let total = 0;

            items.forEach(item => {
              const unitPrice = item?.UnitPrice || 0;
              const amount = item?.Amount || 0;
              const itemDiscount = item?.Discount || 0;

              total += (unitPrice * amount - itemDiscount) * (factors[item?.Currency] || 1);
            });

            const totalAfterDiscount = total - discount;

            return (
              <InputNumber
                value={totalAfterDiscount.toFixed(2)}
                readOnly
                size="small"
                style={{ width: 100, backgroundColor: '#fff' }}
              />
            );
          }}
        </Form.Item>
        $
      </span>

      <span style={{ fontWeight: 'bold', fontSize: '12px', color: '#1890ff' }}>
        مجموع الدفعات: 
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues.Vouchers !== currentValues.Vouchers;
          }}
        >
          {() => {
            const vouchers = form.getFieldValue('Vouchers') || [];
            let sumOfVouchers = 0;
            
            vouchers.forEach(voucher => {
              const value = voucher?.Value || 0;
              const currency = voucher?.Currency || 1;
              const factor = voucher?.Factor || factors[currency] || 1;
              sumOfVouchers += value * factor;
            });
            
            return (
              <InputNumber
                value={sumOfVouchers.toFixed(2)}
                readOnly
                size="small"
                style={{ width: '100px', marginRight: '4px', backgroundColor: '#e6f7ff' }}
              />
            );
          }}
        </Form.Item>
        $
      </span>

      <span style={{ fontWeight: 'bold', fontSize: '12px', color: '#52c41a' }}>
        المتبقي: 
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues.Items !== currentValues.Items || 
                  prevValues.Discount !== currentValues.Discount ||
                  prevValues.Vouchers !== currentValues.Vouchers;
          }}
        >
          {({ getFieldValue }) => {
            const items = getFieldValue('Items') || [];
            const discount = getFieldValue('Discount') || 0;
            const vouchers = getFieldValue('Vouchers') || [];

            let total = 0;

            items.forEach(item => {
              const unitPrice = item?.UnitPrice || 0;
              const amount = item?.Amount || 0;
              const itemDiscount = item?.Discount || 0;

              total += (unitPrice * amount - itemDiscount) * (factors[item?.Currency] || 1);
            });

            const totalAfterDiscount = total - discount;

            let sumOfVouchers = 0;
            vouchers.forEach(voucher => {
              const value = voucher?.Value || 0;
              const currency = voucher?.Currency || 1;
              const factor = voucher?.Factor || factors[currency] || 1;
              sumOfVouchers += value * factor;
            });

            const remaining = totalAfterDiscount - sumOfVouchers;

            return (
              <InputNumber
                value={remaining.toFixed(2)}
                readOnly
                size="small"
                style={{ width: 100, backgroundColor: '#f6ffed' }}
              />
            );
          }}
        </Form.Item>
        $
      </span>
    </div>
  );
};

export default InvoiceTotals;
